import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { VideoFeatures, AutoplayOverlay } from '@/store/videoFeatures';
import { AutoplayTemplateSelector } from '../AutoplayTemplateSelector';
import { AutoplayTextFieldsWithCounter } from '../AutoplayTextFieldsWithCounter';
import { AutoplayStyleSection } from '../AutoplayStyleSection';
// import { AutoplayVideoSelector } from '../AutoplayVideoSelector'; // Removido - não implementado

import { AlertCircle } from 'lucide-react';
// import { Film } from 'lucide-react'; // Removido - usado apenas no vídeo de fundo

interface AutoplayPersonalizationTabProps {
  features: VideoFeatures;
  setFeature: <K extends keyof VideoFeatures>(key: K, value: VideoFeatures[K]) => void;
}

export const AutoplayPersonalizationTab: React.FC<AutoplayPersonalizationTabProps> = ({
  features,
  setFeature
}) => {
  useLanguage();
  const autoplayOverlay = features.autoplayOverlay || {
    enabled: false,
    backgroundStyle: 'darkened',
    backgroundIntensity: 65,
    iconType: 'sound',
    textTop: 'Seu vídeo já começou',
    textBottom: 'Ative o som',
    showIcon: true,
    pulseAnimation: false,
    colors: {
      background: 'rgba(0, 0, 0, 0.55)',
      text: '#ffffff',
      icon: '#ffffff',
      border: 'rgba(255, 255, 255, 0.15)'
    }
  };

  // Mostrar mensagem se autoplay não estiver ativo
  if (!autoplayOverlay.enabled) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-14 h-14 rounded-full bg-muted/30 flex items-center justify-center mb-4">
          <AlertCircle className="h-7 w-7 text-muted-foreground/50" />
        </div>
        <p className="text-base font-medium text-foreground mb-2">
          {translateInterfaceText("Autoplay desativado")}</p>
        <p className="text-sm text-muted-foreground max-w-[300px]">
          {translateInterfaceText("Ative o Smart Autoplay para personalizar o estilo visual.")}</p>
      </div>
    );
  }

  const updateAutoplayOverlay = (key: keyof AutoplayOverlay, value: any) => {
    setFeature('autoplayOverlay', {
      ...autoplayOverlay,
      [key]: value
    });
  };

  // Batch update para evitar race conditions no Range Slider
  const updateAutoplayOverlayBatch = (updates: Partial<AutoplayOverlay>) => {
    setFeature('autoplayOverlay', {
      ...autoplayOverlay,
      ...updates
    });
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto min-h-0 premium-scroll">
        <div className="py-4 space-y-6">
          
          {/* ═══════════════════════════════════════════════════ */}
          {/* FASE 01: Modelos e Mensagens                        */}
          {/* ═══════════════════════════════════════════════════ */}
          
          {/* BLOCO 1 + 2: Modelos de Autoplay (grid 7 + Personalizado) */}
          <AutoplayTemplateSelector
            autoplayOverlay={autoplayOverlay}
            updateAutoplayOverlay={updateAutoplayOverlay}
            updateAutoplayOverlayBatch={updateAutoplayOverlayBatch}
          />

          {/* BLOCO 3: Mensagens do Autoplay */}
          <AutoplayTextFieldsWithCounter
            autoplayOverlay={autoplayOverlay}
            updateAutoplayOverlay={updateAutoplayOverlay}
          />

          {/* ═══════════════════════════════════════════════════ */}
          {/* FASE 02: Estilo e Comportamento (Unificado)         */}
          {/* Detectar Interação agora vive no grid "Efeitos e     */}
          {/* Recursos" do AutoplayStyleSection (junto dos outros).*/}
          {/* ═══════════════════════════════════════════════════ */}

          <AutoplayStyleSection
            autoplayOverlay={autoplayOverlay}
            updateAutoplayOverlay={updateAutoplayOverlay}
            blockPause={features.blockPause}
            onBlockPauseChange={(value) => setFeature('blockPause', value)}
          />

          {/* ═══════════════════════════════════════════════════ */}
          {/* FASE 03: Vídeo de Fundo Inteligente - REMOVIDO      */}
          {/* Recurso não implementado no player                  */}
          {/* ═══════════════════════════════════════════════════ */}

          {/* REMOVIDO - Vídeo de Fundo Inteligente não implementado */}
          {/* <div className="pt-4 pb-2">
            <div className="flex items-center gap-2 mb-1">
              <Film className="h-4 w-4 text-primary" />
            <h3 className="text-[14px] font-semibold text-foreground">
              Vídeo de Fundo Inteligente
            </h3>
            </div>
            <p className="text-xs text-muted-foreground">
              Aumente a retenção com um vídeo gancho no autoplay
            </p>
          </div>

          <AutoplayVideoSelector
            autoplayOverlay={autoplayOverlay}
            updateAutoplayOverlay={updateAutoplayOverlay}
            updateAutoplayOverlayBatch={updateAutoplayOverlayBatch}
          /> */}

        </div>
      </div>
    </div>
  );
};
